import { Link } from 'react-router-dom';

import Typography from '~/shared/components/Typography';
import LinkIcon from '~/shared/assets/icons/link.svg';

import { buildVolumePageUrl } from '~/fleet-manager/components/FleetManagerPage/helpers';

export default function VolumeIdCell({ id, accountId }: { id: string; accountId?: string }) {
  return (
    <Link to={buildVolumePageUrl(id, accountId)} className="flex items-center justify-between w-full">
      <Typography
        color="text-primary-500"
        variant="p3"
        fontWeight={700}
        className="font-family-inter cursor-pointer"
        truncate
      >
        {id}
      </Typography>
      <LinkIcon className="size-5" />
    </Link>
  );
}
